import api from '../api'
import Axios from '../utils/diyaxios'
import _ from '@/utils/util'
import Storage from '@/utils/localstorage'

let isBridgeReady = false
const NA = window.navigator

// 合作渠道
const channel = _.getXChannel() || 'netease';
// 平台类型
const platform = _.getXPlatform();

export default {
    getUser: ({state, commit, dispatch}, params = {}) => {
      return Axios.get(api.getUser(), {
        params: params
      }).then((res) => {
        // 是否已登录
        res.logined = !!(res && res.user_id)
        // 是否体验用户
        res.isFreeUser = !!(res.logined && res.free)
        // 是否VIP用户
        res.isVIPUser = !!(res.logined && res.vip)
        // 剩余体验时间（秒）
        res.remainingFreeTime = res.isFreeUser ? res.free.end_time - res.free.current_time : 0
        // 剩余VIP时间（秒）
        res.remainingVIPTime = res.isVIPUser ? res.vip.end_time - res.vip.current_time : 0
        // 剩余获赠时间（秒）
        res.remainingAwardedTime = res.logined ? res.free_time_left : 0
        // pc vip用户
        res.isPcVIPUser = !!(res.logined && res.coins > 0)
        // pc 剩余获赠时间（秒）
        res.remainingPcAwardedTime = res.logined ? res.pc_free_time_left : 0;
        // 云手机剩余时间（秒）
        res.remainingCloudMobileTime = (res.logined && res.cloud_mobile) ? res.cloud_mobile.expire_time - res.cloud_mobile.current_time : 0; // 秒
        // 云电脑剩余时间（秒）
        res.remainingCloudPcTime = (res.logined && res.cloud_pc) ? res.cloud_pc.expire_time - res.cloud_pc.current_time : 0; // 秒

        // 如果是之前未登录状态，则拉一次消息
        if (!state.user.logined) {
          dispatch('getMessages', { id: 0 });
        }

        if (window.NG_ACTIVITY && window.NG_ACTIVITY.has('getUser')) {
          return new Promise((reslove) => {
            window.NG_ACTIVITY.emit('getUser', res, params, (user) => {
              commit('setUser', user)
              commit('setUid', user.user_id)
              reslove(user);
            });
          });
        }

        console.log('用户的信息', res)
        commit('setUser', res)
        commit('setUid', res.user_id)
        return res
      }, (res) => {
        // 认证失败时，才清掉用户信息
        if (res.status == 401) {
          commit('setUser', {})
          commit('setMessages', [])
        }
        console.log('这里出错了吗？？？', res)
        return Promise.reject(res)
      })
    },
    getCtcodes: () => {
        const storageKey = 'NCG-ctcodes-ys'
        const list = Storage.get(storageKey) || []
        if (list.length) {
          return list
        }
        return Axios.get(api.getCtcodes()).then((res) => {
            console.log('获取到的列表')
            // 存大概1天
            Storage.set(storageKey, res, 24 * 60 * 60 * 1000)
            return res
          }, () => {})
    },
    getToken: ({commit}, params = {}) => {
      console.log('getToken', params)
      let getTokenAxios
      // 虚拟手柄登录
      if (params.qrcode_id && !params.phone) {
        getTokenAxios = Axios.get(api.getToken(), {
          params: {
            qrcode_id: params.qrcode_id
          }
        })
      } else {
        getTokenAxios =  Axios.post(api.getToken(), params)
      }
      return getTokenAxios.then((res) => {
        //加密信息
        console.log('getToken login- 22----------',res)
        const encrypt = _.cookieSet(_.randomSplit(res.encrypt))
        const EID = _.cookieGet(encrypt)
        const OFFSET = _.getOffset2(EID)
        commit('setOFFSET', OFFSET)
        // 更新用户信息debug信息
        commit('setUid', res.user_id)
        commit('setUser', {
          user_id: res.user_id,
          debug: res.debug
        })
        // gamepad或者快速开启，快速快启，token为备份
        console.log('token', res.token)
        commit('setToken', res.token)
        if (params.auth_method === 'phone-captcha' || params.auth_method === 'auth-token') {
          Storage.set('NCG-token-ys', res.token)
          Storage.set('NCG-eid-ys', encrypt)
          Storage.set('NCG-id-ys', res.user_id)
        } else {
          Storage.set('NCG-eid-other-ys', encrypt)
          Storage.set('NCG-token-other-ys', res.token)
        }
        return res
      }, (res) => {
        console.log('是这里出token异常???', res)
        return Promise.reject(res)
      })
    },
    getDevInfo: ({commit, state}) => {
      const info = state.devInfo
      if (info.userAgent) {
        return info
      }
      // 初始基本数据
      const isNetease = _.getDetect().os.neteaseCloud
      commit('setDevInfo', {
        userAgent: NA.userAgent,
        appVersion: NA.appVersion
      })

      // 非apk内
      if (!isNetease) {
        const isMobile = _.isMobile()
        const codecs = (isMobile && Storage.get('NCG-codecs-ys')) || []
        // 移动是否有本地默认的编码方式
        if (codecs.length) {
          commit('setDevInfo', {
            codecs: codecs
          })
          return codecs
        }
        return _.getVideoCodecs().then((data) => {
          commit('setDevInfo', {
            codecs: data.codecs
          })
        })
      }

      // apk内
      return new Promise((resolve) => {
        // 已注册处理
        if (isBridgeReady) {
          resolve(state.devInfo)
          return
        }
        const callBack = () => {
          if (isBridgeReady) {
            return
          }
          isBridgeReady = true
          // 新增获取到的ua信息
          window.NCGJsBridge.getDevInfo((devInfo) => {
            console.log('apk设备信息等', devInfo)
            const info = JSON.parse(devInfo)
            const dev = info.device
            dev.sdk = info.sdk
            // 编码转译
            dev.codecs = (dev.codec || '').toLowerCase().split(',')
            commit('setDevInfo', dev)
            resolve(state.devInfo)
          })
        }

        if (window.NCGJsBridge && window.NCGJsBridge.getDevInfo) {
          console.log('NCGJsBridge已注册')
          callBack()
        } else {
          console.log('NCGJsBridge未注册')
          document.addEventListener('NCGJsBridgeReady', callBack, false)
        }

      })
    },
    postBehaviors: ({state}, params) => {
      const uid = state.user.user_id;
      const header = {
        'X-Auth-User': 'a29',
        'X-Content-Type': 'application/list',
        'X-Auth-Token': process.env.VUE_APP_BEHAVIOR_AUTH_TOKEN
      };
      let behaviorData = {
        "action": params.action,
        "event": "behavior",
        "project": process.env.VUE_APP_BEHAVIOR_PROJECT,
        "secret": process.env.VUE_APP_BEHAVIOR_SECRET,
        "channel": channel,
        "source": "client",
        "platform": platform,
        "unique_id": _.getUniqueId(),
        "timestamp": +new Date(),
        "extra_data": params
      };
      if (uid) {
        behaviorData.user_id = uid;
        behaviorData.ctcode = state.user.ctcode
        behaviorData.register_time = state.user.create_time;
        // 带上is_vip参数
        behaviorData.vip = state.user.is_vip
      }

      return Axios.post(process.env.VUE_APP_LOGIC_BEHAVIOR, [behaviorData], {
        transformRequest: [(data, headers) => {
          delete headers['X-Platform']; // 上传接口不能包含多余字段
          delete headers['X-Channel']; // 上传接口不能包含多余字段
          delete headers['X-Ver']; // 上传接口不能包含多余字段
          delete headers['X-Source-Type']; // 上传接口不能包含多余字段
  
          headers['Content-Type'] = 'application/json;charset=UTF-8';
          return JSON.stringify(data);
        }],
        headers: header
      })
		},
		getClientSettings({state}) {
			const user = state.user;
			const version = user.user_id ? 'v2' : 'v1';
			return Axios.get(api.getClientSettings(version)).then((res) => {
				return res
			});
		}
}